<fc-header />
<router-outlet></router-outlet>
<fc-footer />
